/**
 * @name cookie
 * @description
 * Work with cookies without jQuery
 */
export default class Cookie {

    constructor() {}

    /**
     * @name getCookie
     * @description
     * Get Cookies
     * @param {string} name Cookies name
     * @returns {string} Value of cookie
     */
    getCookie(name) {
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) return match[1];
        return;
    }

    /**
     * @name setCookie
     * @description
     * Set a cookie
     * @param {string} name Cookie name
     * @param {string} value Value of cookie
     * @param {obj} time.minutes Minutes to expiration cookie
     * @param {obj} time.days Days to expiration cookie
     * @param {obj} time.hours Hours to expiration cookie
     */
    setCookie(name, value, time, domain, sameSite, secure) {
        let date = new Date();
        if (time.minutes) date.setTime(date.getTime() + time.minutes * 60000);
        if (time.hours) date.setTime(date.getTime() + (time.hours * 60 * 60 * 1000));
        if (time.days) date.setDate(date.getDate() + time.days);

        const config = [
            name + '=' + value,
            'expires=' + date.toUTCString(),
            'path=/',
            domain ? 'domain=' + domain : '',
            sameSite ? 'SameSite=' + sameSite : '',
            secure ? 'Secure' : ''
        ].filter(Boolean);

        document.cookie = config.join(';');
        return value;
    }

}